import { DOC_TYPES } from '$lib/components/document/doc_types'

export function match(value) {

	return DOC_TYPES.some((v) => value === v)
}
